import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-control-icon',
  templateUrl: './code-control.component.html'
})
export class CodeControlComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
